import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import IconButton from './IconButton';
import Modal from './Modal';
import WildlifeThreatLevelSelector from './WildlifeThreatLevelSelector';

class WildlifeThreatCell extends Component {

  state = {
    isFilterOpen: false,
  };

  showFilter(show) {
    this.setState({
      isFilterOpen: show,
    });
  }

  render() {
    return (
      <div
        className="WildlifeThreatCell"
        ref="target"
      >
        <p className="WildlifeThreatCell__title">
          Threat Level Filter
        </p>
        <IconButton
          styleName="WildlifeThreatCell__button"
          onClick={() => this.showFilter(true)}
        />

        <Modal
          target={ props => findDOMNode(this.refs.target)}
          placement="right"
          show={this.state.isFilterOpen}
          onHide={() => this.showFilter(false)}
        >
          <WildlifeThreatLevelSelector
            wildlifeContext={this.props.wildlifeContext}
          />
        </Modal>
      </div>
    );
  }
}

WildlifeThreatCell.propTypes = {
  wildlifeContext: PropTypes.string.isRequired,
};

export default WildlifeThreatCell;



// WEBPACK FOOTER //
// ./src/components/WildlifeThreatCell.js